import React from 'react';
import { Grid3X3, List } from 'lucide-react';
import { useAppSelector } from '../../store/hooks';

export type ViewMode = 'table' | 'grid';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  className?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ 
  currentView, 
  onViewChange, 
  className = '' 
}) => {
  const { theme } = useAppSelector((state) => state.ui);
  const viewOptions = [
    { 
      mode: 'table' as ViewMode, 
      icon: List, 
      label: 'Table',
      description: 'Table layout'
    },
    { 
      mode: 'grid' as ViewMode, 
      icon: Grid3X3, 
      label: 'Grid',
      description: 'Grid layout'
    }
  ];

  return (
    <div className={`flex items-center space-x-1 rounded-lg p-1 ${className} ${
      theme === 'dark' ? 'bg-gray-800' : 'bg-gray-100'
    }`}>
      {viewOptions.map(({ mode, icon: Icon, label, description }) => (
        <button
          key={mode}
          onClick={() => onViewChange(mode)}
          className={`
            flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors
            ${currentView === mode
              ? theme === 'dark' 
                ? 'bg-gray-700 text-white shadow-sm' 
                : 'bg-white text-primary-600 shadow-sm'
              : theme === 'dark'
                ? 'text-gray-300 hover:text-white hover:bg-gray-700'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
            }
          `}
          title={description}
        >
          <Icon className="h-4 w-4" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
